export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/hotel/front/home',
      name: 'distributor-hotel-front-home',
      meta: {
        skip_check_token: true,
        footer_margin_none: true,
      },
      component: () => import('@/page/distributor/hotel/front/hotel-home/1.0.1/index.vue'),
    },
  ]
};
